import { Box, Divider, Link, styled } from "@mui/material";

export const ReceiptContainer = styled(Box)(({ theme }) => ({
    fontFamily: 'RobotoMono',
    textAlign: 'start',
    minWidth: '400px',
    border: '1px solid rgb(181, 181, 181)',
    borderRadius: '3px',
    padding: '20px',
    background: 'rgb(253, 253, 253)'
}));

export const ReceiptOrganizationHeaderContainer = styled(Box)(({ theme }) => ({
    textAlign: 'center',
}));

export const ReceiptLine = styled(Box)(({ theme }) => ({
    textAlign: 'start',
}));

export const ReceiptTotal = styled(Box)(({ theme }) => ({
    textAlign: 'end',
    fontSize: '20pt',
}));

export const ReceiptDivider = styled(Divider)(({ theme }) => ({
    marginTop: '10px',
    marginBottom: '10px'
}));

export const ReceiptContent = styled(Box)(({ theme }) => ({
    marginTop: '35px',
    marginBottom: '35px',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    alignItems: 'center'
}));

export const A = styled(Link)(({ theme }) => ({
    display: 'contents',
    color: 'inherit'
}));
